import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { IconModel } from "../../../icon/model/icon.model";
import { Tires } from "./model/tires";
import { IconComponent } from "../../../icon/icon.component";

@Component({
  selector: "rfc-tires-column",
  templateUrl: "./tires-column.component.html",
  styleUrls: ["./tires-column.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    IconComponent
  ]
})
export class TiresColumnComponent {
  @Input() tires: Tires;

  summerIcon: IconModel;
  winterIcon: IconModel;

  constructor() {
    this.summerIcon = {
      iconName: "light_mode",
      isMatIcon: true
    };

    this.winterIcon = {
      iconName: "ac_unit",
      isMatIcon: true
    };
  }
}
